import React, { useState } from 'react';
import { ChevronDownIcon, MapIcon } from 'lucide-react';
import { useDemo } from '../../contexts/DemoContext';
import { storySteps } from '../../data/storySteps';
export function SceneNavigator() {
  const {
    state,
    dispatch
  } = useDemo();
  const [open, setOpen] = useState(false);
  const currentIndex = storySteps.findIndex(step => step.screens.includes(state.currentScreen));
  if (currentIndex < 0) return null;
  const current = storySteps[currentIndex];
  return <div className="border-b border-line bg-paper" data-id="element-470" data-mp="irhd3hqt1k76">
      <div className="mx-auto flex max-w-6xl items-center gap-4 px-3 py-1 sm:px-6" data-id="element-471" data-mp="iqoe52y37yzl">
        <button type="button" aria-expanded={open} aria-controls="story-steps-list" onClick={() => setOpen(value => !value)} className="flex min-h-[44px] items-center gap-2 rounded-full px-2 text-sm text-forest transition-colors duration-150 hover:bg-sand" data-id="element-472" data-mp="xeso9ij2r26r">
          <MapIcon size={18} aria-hidden="true" data-id="element-473" data-mp="11jilbapgymt9" />
          <span className="font-bold" data-id="element-474" data-mp="1vvxz0oxdrjfz">Story steps</span>
          <span className="text-ink/80" data-id="element-475" data-mp="1vxiucgrir6ew">· {current.label}</span>
          <ChevronDownIcon size={16} aria-hidden="true" className={`transition-transform duration-200 ease-out ${open ? 'rotate-180' : ''}`} data-id="element-476" data-mp="20vkaotxk8rmo" />
        </button>
        <ol aria-hidden="true" className="hidden flex-1 items-center gap-1 md:flex" data-id="element-477" data-mp="2atgm7muetolb">
          {storySteps.map((step, index) => {
          const reached = step.screens.some(screen => state.visitedScreens.includes(screen));
          return <li key={step.id} className={`h-1.5 flex-1 rounded-full ${index === currentIndex ? 'bg-teal' : reached ? 'bg-leaf' : 'bg-line'}`} data-id="element-478" data-mp="2ok3jrbofp8ft" data-mpi={index} />;
        })}
        </ol>
      </div>
      {open && <ol id="story-steps-list" className="anim-enter mx-auto grid max-w-6xl gap-1 px-3 pb-3 sm:grid-cols-2 sm:px-6 md:grid-cols-4" data-id="element-479" data-mp="32jutv1bty4oj">
          {storySteps.map((step, index) => {
        const reached = step.screens.some(screen => state.visitedScreens.includes(screen));
        const isCurrent = index === currentIndex;
        return <li key={step.id} data-id="element-480" data-mp="1c884jmbgxiv5" data-mpi={index}>
                <button type="button" disabled={!reached || isCurrent} aria-current={isCurrent ? 'step' : undefined} onClick={() => {
            setOpen(false);
            dispatch({
              type: 'GO',
              screen: step.entry
            });
          }} className={`flex min-h-[44px] w-full items-center justify-between gap-2 rounded-xl px-3 text-left text-sm transition-colors duration-150 ${isCurrent ? 'bg-teal font-bold text-cream' : reached ? 'text-forest hover:bg-sand' : 'cursor-default text-ink/80'}`} data-id="element-481" data-mp="1c99hjwc1offi">
                  <span data-id="element-482" data-mp="3it6ol3sx9mt1">{step.label}</span>
                  <span className="text-xs" data-id="element-483" data-mp="3iu887wo07hmd">{isCurrent ? 'You are here' : reached ? 'Visited' : 'Not reached yet'}</span>
                </button>
              </li>;
      })}
        </ol>}
    </div>;
}